export enum LoginLinkEvents {
  clickIconAuthorization = 'click_icon_authorization',
}
